"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BOMWidget_1 = __importDefault(require("./BOMWidget"));
exports.default = BOMWidget_1.default;
